import { defaultAllowedFileTypes } from '@shared/validators';
import { MimeType } from '../types';

/**
 * Builds the Replace Document file input's `accept` attribute (ERM-12396/12397).
 *
 * ERM-12317: the allow-list is the shared `defaultAllowedFileTypes` — the AC holds a
 * replacement to the same restrictions as a first upload, and the backend defers to Iris DM's
 * `document/validate/` rather than enforcing a narrower set of its own. The mime strings for
 * those extensions come from the backend's `document/mime_type/` registry rather than being
 * retyped in the frontend, which is what lets the native file picker filter by type as well
 * as by extension.
 *
 * @param mimeTypes The backend mime-type registry; may be empty before it loads.
 * @returns An `accept` value, extensions only when the registry is unavailable.
 */
export function buildReplaceAcceptAttribute(mimeTypes: MimeType[]): string {
  const _extensions = defaultAllowedFileTypes.map(
    (extension) => `.${extension}`,
  );

  const _mimeNames = (mimeTypes ?? [])
    .filter((mimeType) =>
      defaultAllowedFileTypes.includes(
        (mimeType?.extension ?? '').toLowerCase(),
      ),
    )
    .map((mimeType) => mimeType.name)
    .filter((name): name is string => !!name);

  return [..._extensions, ...new Set(_mimeNames)].join(',');
}
